module.exports = "<div class=\"gw-page gw-box gw-activities-view\">\r\n    <h1 class=\"gw-page-title\">{{'claim.views.activities.Activities' | translate}}</h1>\r\n\r\n    <div gw-claim-activity-summary class=\"gw-activity-summary\"></div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/claim/views/activities.html
// module id = 568
// module chunks = 0